<template>
    <div class="container pt-2">
        <PageTitle icon="fa fa-address-card" main="Confirmar Pagamento do Job" sub="Confirmar pagamento dos jobs" />

        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-jobs" 
                class="text-center table table-sm" 
                :items="jobs" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(diferenca_valor)="data">
                    R${{ (data.item.id_tiposervico_valor_receber - data.item.id_tiposervico_valor_pagar).toFixed(2).toString().replace(".", ",") }}
                </template>
                <template v-slot:cell(actions)="data">
                    <b-button variant="success" class="mr-2 btn-sm mb-1 btn-size" @click="setConfirm(data.item)"
                        v-if="data.item.status==='AGUARDANDO CONFIRMACAO' && 
                        nivel==='admin'">
                        <font-awesome-icon :icon="['fa', 'file-invoice-dollar']"/>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-jobs"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
        <div v-else>
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-jobs" 
                class="text-center table table-sm" 
                :items="jobs" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(diferenca_valor)="data">
                    R${{ (data.item.id_tiposervico_valor_receber - data.item.id_tiposervico_valor_pagar).toFixed(2).toString().replace(".", ",") }}
                </template>
                <template v-slot:cell(actions)="data">
                    <b-button variant="success" class="mr-2 btn-sm mb-1 btn-size" @click="setConfirm(data.item)"
                        v-if="data.item.status==='AGUARDANDO CONFIRMACAO' && 
                        nivel==='admin'">
                        <font-awesome-icon :icon="['fa', 'file-invoice-dollar']"/>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-jobs"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: 'confirmaJobs',
    components: { PageTitle },
    directives: {},
    data: function() {
        return {
            jwt: new VueEasyJwt(),
            nivel: '',
            job: {},
            jobs: [],
            transacao1: {},
            transacao2: {},
            quemRecebeu: '',
            exibeRodape: true,
            currentPage: 1,
            filtro: null,
            filtrando: [],
            totalRows: 1,
            fields: [
                { key: 'numero', label: 'Número', sortable: true },
                { key: 'id_tiposervico_valor_receber', label: 'Valor Total', sortable: true, formatter: 'formatMoney' },
                { key: 'id_tiposervico_valor_pagar', label: 'Valor Repasse', sortable: true, formatter: 'formatMoney' },
                { key: 'diferenca_valor', label: 'Valor Próprio', sortable: true },
                { key: 'id_tiposervico_datavalidade', label: 'Data Limite', sortable: true, formatter: 'formatData' },
                { key: 'actions', label: 'Ações', thStyle: { width: '20%' }  }
            ],
            larguraTela: 0,
            overflowValue: 'auto'
        }
    },
    computed: {
        rows() {
            return this.jobs.length
        }
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        setConfirm(job) {
            this.job = job
            axios['put'](`${baseApiUrl}/backend/GENERAL/confirmacaoRealizada.php?id=${job.id}`, job)
            .then(() => {

                this.transacao1.id_colaborador = 999
                this.transacao1.id_job = this.job.id
                this.transacao1.id_servico = this.job.id_tiposervico
                this.transacao1.status = 'PAGO_JOB_' + this.job.id
                this.transacao1.tipo = 'credito'
                this.transacao1.valor = this.job.id_tiposervico_valor_receber
                this.transacao1.liberado = 'sim'
                axios['post'](`${baseApiUrl}/backend/INSERT/transacoes.php`, this.transacao1)
                .then(() => {
                })
                .catch((e) => {
                    this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                })

                this.transacao2.id_colaborador = this.job.quemPublicou
                this.transacao2.id_job = this.job.id
                this.transacao2.id_servico = this.job.id_tiposervico
                this.transacao2.status = 'PAGO_JOB_' + this.job.id
                this.transacao2.tipo = 'debito'
                this.transacao2.valor = this.job.id_tiposervico_valor_receber
                this.transacao2.liberado = 'sim'
                axios['post'](`${baseApiUrl}/backend/INSERT/transacoes.php`, this.transacao2)
                .then(() => {
                    this.$toasted.global.defaultSuccess({ message : 'Pagamento confirmado com sucesso!' })
                })
                .catch((e) => {
                    this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                })

                this.reset()
            })
            .catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
            })
        },
        formatData(value) {
            const arr = value.split('-')
            const y = arr[0]
            const m = arr[1]
            const d = arr[2]
            return `${d}/${m}/${y}`
        },
        formatMoney(value) {
            if(value.indexOf('.') > -1) {
                const arr = value.split('.')
                const r = arr[0]
                const c = arr[1]
                if(c.length < 2) {
                    return `R$${r},${c}0`
                } else {
                    const c1 = arr[1].charAt(0)
                    const c2 = arr[1].charAt(1)
                    return `R$${r},${c1}${c2}`
                }
            } else {
                return `R$${value},00`
            }
        },
        loadJobs() {
            const url = `${baseApiUrl}/backend/SELECT/jobsByStatus.php?status=AGUARDANDO CONFIRMACAO`
            axios.get(url).then(res => {
                this.jobs = res.data
                this.exibeRodape = false
            }).catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                this.exibeRodape = true
            })
        },
        reset() {
            this.job = {}
            this.filejob = {}
            this.transacao1 = {}
            this.transacao2 = {}
            this.loadJobs()
            this.$v.job.$reset()
            this.tabIndex--
            this.arquivoIndex = 0
        },
        loadJob(job) {
            this.job = { ...job }
            // this.loadCategorias()
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.nivel = decodedToken['data'].nivel
                this.quemRecebeu = decodedToken['data'].id
            }
        }
    },
    mounted() {
        this.validaLogin()
        if(this.nivel !== 'admin') {
            this.$router.push('/')
        }
        this.loadJobs()
        this.larguraTela = screen.width - (screen.width * 0.08)
        this.totalRows = this.jobs.length
    }
}
</script>

<style>
.table {
    font-size: 0.9rem;
}

.text-custom {
    font-size: 0.8rem;
}
</style>